// extracted by mini-css-extract-plugin
export default {"loader_container":"Loanding_loader_container__Zthm+","loader":"Loanding_loader__Jb+I1"};